import { AnalyticsButtonLabels, trackButtonClick } from '@atlassian/temp-analytics';
import { getEnvironment, PRODUCTION, STAGING } from '@atlassian/temp-shared';
import { NavigationGroup, NavigationItem, NavigationLink } from '@css-xp/graphtypes';
import { helpLegalLinks } from '@css-xp/ppc-consent-hub';
import {
  ATLASSIAN_START_STG_URL,
  ATLASSIAN_START_URL,
  CREDIT_REQUEST_UI_URL,
  CREDIT_REQUEST_UI_STG_URL,
  RESOURCE_HUB_URL,
  PARTNER_MANAGED_SUBSCRIPTIONS_STG_URL,
  PARTNER_MANAGED_SUBSCRIPTIONS_URL,
  PARTNER_PORTAL_URL,
  GSAC_BASE_URL,
  GSAC_BASE_STG_URL,
  PARTNER_SUPPORT_STG_URL,
  PARTNER_SUPPORT_URL,
  ATLASSIAN_SUPPORT_SANDBOX_DELETION_URL_STAGING,
  ATLASSIAN_SUPPORT_SANDBOX_DELETION_URL,
} from '@css-xp/ppc-constants';
import { getPartnerServiceDeskUrlForGenericHelp } from './partner-service-desk-utils-v2';

enum ENV {
  PRODUCTION = 'production',
}

export const getAtlassianStartUrl = () => {
  switch (getEnvironment()) {
    case STAGING:
      return ATLASSIAN_START_STG_URL;
    case PRODUCTION:
      return ATLASSIAN_START_URL;
    default:
      return ATLASSIAN_START_STG_URL;
  }
};

export const getPartnerSubscriptionsUrl = () => {
  switch (getEnvironment()) {
    case PRODUCTION:
      return PARTNER_MANAGED_SUBSCRIPTIONS_URL;
    default:
      return PARTNER_MANAGED_SUBSCRIPTIONS_STG_URL;
  }
};

export const getPartnerPortalUrl = () => {
  return PARTNER_PORTAL_URL;
};

export const getResourceHubUrl = () => {
  return RESOURCE_HUB_URL;
};

export const isNavigationLink = (item: NavigationItem): item is NavigationLink => {
  return (item as NavigationLink).url !== undefined;
};

export const isNavigationGroup = (item: NavigationItem): item is NavigationGroup => {
  return (item as NavigationGroup).links !== undefined;
};

export const handleSupportLinkClick = () => {
  window.open(getPartnerServiceDeskUrlForGenericHelp(), '_blank');
  trackPartnerServiceDeskClick();
};

export const handleResourceHubLinkClick = () => {
  window.open(getResourceHubUrl(), '_blank');
};

export const handlePPCTermsOfUseClick = () => {
  window.open(helpLegalLinks.termsOfUseUrl, '_blank');
};

export const handlePPCPrivacyPolicyClick = () => {
  window.open(helpLegalLinks.privacyPolicyUrl, '_blank');
};

export const trackPartnerServiceDeskClick = () => {
  return trackButtonClick(AnalyticsButtonLabels.PARTNER_SERVICE_DESK);
};

export const getCreditUsageUiUrl = (transactionId: string) => {
  switch (getEnvironment()) {
    case PRODUCTION:
      return `${CREDIT_REQUEST_UI_URL}/${transactionId}`;
    default:
      return `${CREDIT_REQUEST_UI_STG_URL}/${transactionId}`;
  }
};

export const getGSACSupportUrl = (supportTicketNumber: string) => {
  switch (getEnvironment()) {
    case PRODUCTION:
      return `${GSAC_BASE_URL}/browse/${supportTicketNumber}`;
    default:
      return `${GSAC_BASE_STG_URL}/browse/${supportTicketNumber}`;
  }
};

export const getSupportTicketDetails = (supportTicket?: string | null) => {
  const supportTicketNumber = supportTicket && supportTicket?.split('/')?.pop();
  const supportTicketUrl = supportTicket && getGSACSupportUrl(supportTicketNumber as string);
  return { supportTicketNumber, supportTicketUrl };
};

export const getSandboxesDeletionDocUrl = () => {
  switch (getEnvironment()) {
    case PRODUCTION:
      return ATLASSIAN_SUPPORT_SANDBOX_DELETION_URL;
    default:
      return ATLASSIAN_SUPPORT_SANDBOX_DELETION_URL_STAGING;
  }
};
